import React from 'react';

const SvgClearSelection: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11 19.5H4m7-5H4m16-5H4m16-5H4m11 10l5 5m0-5l-5 5"
      />
    </svg>
  );
};

export default SvgClearSelection;
